<template>
<div class="list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" class="search" placeholder="Search" v-model="filters.search_term" @search="getList(1)">
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="!showDetail" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">

        <div v-if="!showDetail">

            <label>Transaction Type</label>
            <select v-model="filters.ffl_transaction_type_id" @change="getList(1)">
                <option value="">Select...</option>
                <option v-for="type in fflTransactionTypes" :value="type.ffl_transaction_type_id">{{ type.description }}</option>
            </select>
            <div class="divider"></div>

            <label class="full-width" style="margin: 0 0 0.5em 0;">Transaction Date</label>
            <div class="label-group">
                <label>Start</label>
                <input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
            </div>
            <div class="label-group">
                <label>End</label>
                <input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
            </div>
            <div class="label-group">
                <label></label>
                <div class="button small neutral" @click="getList(1)">Filter Dates</div>
            </div>

            <div class="divider"></div>
            <div :class="['button', hasFilters ? 'neutral' : 'disabled' ]" @click="clearFilters(true)">Clear Filters</div>
            <div class="divider"></div>
            <!-- <div :class="['extra-menu-item', { 'disabled': list.length < 1 }]" @click="showExportOptions = true">Export List</div> -->
        </div>
        <div v-else>
            <div class="button action" @click="saveDetail()">Save Transaction</div>
            <div class="button neutral" @click="showPDFOptions = true">Print to PDF</div>
            <div class="divider"></div>
            <div class="button neutral" @click="backToList()">Back To List</div>
        </div>
	</div>

	<div v-if="!showDetail" class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Date</th>
					<th class="list">Type</th>
					<th class="list">Full Name</th>
					<th class="list">Serial Number</th>
					<th class="list">Gun Type</th>
					<th class="list">Manufacturer</th>
					<th class="list">Model</th>
					<th class="list">Caliber</th>
					<th class="list">Finish</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getDetail(item.ffl_transaction_log_id)" :key="index">
				<td class="list">{{ item.transaction_date }}</td>
				<td class="list">{{ item.transaction_type }}</td>
				<td class="list">{{ item.full_name }}</td>
				<td class="list">{{ item.serial_number }}</td>
				<td class="list">{{ item.gun_type }}</td>
				<td class="list">{{ item.manufacturer }}</td>
				<td class="list">{{ item.model }}</td>
				<td class="list">{{ item.caliber }}</td>
				<td class="list">{{ (item.firearm_data.finish).capitalizeWords() }}</td>
			</tr>
		</table>

	</div>

	<div v-if="showDetail" class="detail">
        <div class="three-columns align-items-start" style="grid-template-columns: 1fr 1fr 0.66fr; grid-column-gap: 2em;">
            <div>
                <h2>Transaction Information</h2>
                <div class="two-columns">
                    <div>
                        <label>Transaction Date</label>
                        <input type="date" v-model="detail.transaction_date">
                    </div>
                    <div>
                        <label>Transaction Type</label>
						<select v-model="detail.ffl_transaction_type_id" disabled>
							<option value="">Select...</option>
							<option v-for="type in fflTransactionTypes" :value="type.ffl_transaction_type_id">{{ type.description }}</option>
						</select>
                    </div>
                </div>
                <label>Full Name</label>
                <input type="text" v-model="detail.full_name">
                <label>Address</label>
                <input type="text" v-model="detail.contact_data.address_1">
                <label>City</label>
                <input type="text" v-model="detail.contact_data.city">
                <div class="two-columns">
                    <div>
                        <label>State</label>
                        <input type="text" v-model="detail.contact_data.state">
                    </div>
                    <div>
                        <label>Zip Code</label>
                        <input type="text" v-model="detail.contact_data.zip_code">
                    </div>
                    <div>
                        <label>Date of Birth</label>
                        <input type="date" v-model="detail.contact_data.date_of_birth">
                    </div>
                    <div>
                        <label>Occupation</label>
                        <input type="text" v-model="detail.contact_data.occupation">
                    </div>
                </div>
                <div v-if="detail.ffl_transaction_type_code == 'ACQUISITION'" style="margin-top: 1.5em;">
                    <h2>Receipt</h2>
                    <div class="two-columns">
                        <div>
                            <label>State Permit Number</label>
                            <input type="text" v-model="detail.receipt_data.receipt_dealer_permit_number">
                        </div>
                        <div>
                            <label>FFL Number</label>
                            <input type="text" v-model="detail.receipt_data.receipt_ffl_number">
                        </div>
                    </div>
                </div>
                <div v-if="detail.ffl_transaction_type_code == 'DISPOSITION'" style="margin-top: 1em;">
                    <h2>Disposition</h2>
                    <div>
                        <label>Disposition Type</label>
						<select v-model="detail.disposition_data.disposition_type">
							<option value="">Select...</option>
							<option value="sold">Sold</option>
							<option value="transfer_customer">Transfer to a consumer</option>
							<option value="transfer_ffl">Transfer to another Federal Firearms Licensee (FFL) at wholesale</option>
							<option value="returned">Returned to original owner</option>
							<option value="rental">Rental</option>
							<option value="other">Other</option>
						</select>
                    </div>
                    <div v-if="detail.disposition_data.disposition_type == 'other'">
                        <label>Other Description</label>
                        <input type="text" v-model="detail.disposition_data.disposition_type_other">
                    </div>
                    <div class="two-columns">
                        <div>
                            <label>State Permit Number</label>
                            <input type="text" v-model="detail.disposition_data.disposition_dealer_permit_number">
                        </div>
                        <div>
                            <label>FFL Number</label>
                            <input type="text" v-model="detail.disposition_data.disposition_ffl_number">
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h2>Dealer Information</h2>
                <div class="two-columns">
                    <div>
                        <label>FFL Number</label>
                        <input type="text" v-model="detail.dealer_data.ffl_number">
                    </div>
                    <div>
                        <label>State Permit Number</label>
                        <input type="text" v-model="detail.dealer_data.state_permit_number">
                    </div>
                </div>
                <div>
                    <label>Business Name</label>
                    <input type="text" v-model="detail.dealer_data.company_name">
                </div>
                <div>
                    <label>Doing Business As</label>
                    <input type="text" v-model="detail.dealer_data.dba_name">
                </div>
                <div>
                    <label>Address</label>
                    <input type="text" v-model="detail.dealer_data.address_1">
                </div>
                <div class="two-columns">
                    <div>
                        <label>City</label>
                        <input type="text" v-model="detail.dealer_data.city">
                    </div>
                    <div>
                        <label>County</label>
                        <input type="text" v-model="detail.dealer_data.county">
                    </div>
                    <div>
                        <label>State</label>
                        <input type="text" v-model="detail.dealer_data.state">
                    </div>
                    <div>
                        <label>Zip Code</label>
                        <input type="text" v-model="detail.dealer_data.zip_code">
                    </div>
                    <div>
                        <label>Phone Number</label>
                        <input type="text" v-model="detail.dealer_data.phone_number">
                    </div>
                    <div>
                        <label>Email Address</label>
                        <input type="text" v-model="detail.dealer_data.email_address">
                    </div>
                    <div>
                        <label>Employee Name</label>
                        <input type="text" v-model="detail.dealer_data.employee_name">
                    </div>
                </div>
            </div>
            <div>
                <h2>Firearm Information</h2>
                <div>
                    <label>Type</label>
                    <input type="text" v-model="detail.firearm_data.gun_type">
                </div>
                <div>
                    <label>Make</label>
                    <input type="text" v-model="detail.firearm_data.manufacturer">
                </div>
                <div>
                    <label>Model</label>
                    <input type="text" v-model="detail.firearm_data.model">
                </div>
                <div>
                    <label>Caliber</label>
                    <input type="text" v-model="detail.firearm_data.caliber">
                </div>
                <div>
                    <label>Finish</label>
					<select v-model="detail.firearm_data.finish">
						<option value="">Select...</option>
						<option value="black">Black</option>
						<option value="blue_steel">Blue Steel</option>
						<option value="nickel">Nickel</option>
						<option value="stainless_steel">Stainless Steel</option>
						<option value="two_toned">Two-Toned</option>
						<option value="cerakote">Cerakote</option>
						<option value="other">Other</option>
					</select>

                    <div v-if="detail.firearm_data.finish == 'two_toned'" class="two-columns">
                        <div>
                            <label>Tone 1</label>
                            <input type="text" v-model="detail.firearm_data.finish_two_toned_1">
                        </div>
                        <div>
                            <label>Tone 2</label>
                            <input type="text" v-model="detail.firearm_data.finish_two_toned_2">
                        </div>
                    </div>
                    <div v-if="detail.firearm_data.finish == 'cerakote'">
                        <label>Color</label>
                        <input type="text" v-model="detail.firearm_data.finish_cerakote">
                    </div>
                    <div v-if="detail.firearm_data.finish == 'other'">
                        <label>Other Finish</label>
                        <input type="text" v-model="detail.firearm_data.finish_other">
                    </div>
                </div>
                <div>
                    <label>Serial Number</label>
                    <input type="text" v-model="detail.serial_number">
                </div>
            </div>
        </div>
	</div>

	<div class="modal" v-if="showExportOptions">
		<div class="inner">
			<h2>Export Firearms Transactions</h2>
			<div class="content">
				<div v-if="filters.start_date && filters.end_date">
					<p>Export Firearms Transactions coming soon.</p>
				</div>
				<div v-else>
					<p>Please select a date range before printing this report.</p>
				</div>
			</div>
			<div class="controls">
				<div class="button neutral spaced" @click="showExportOptions = false">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showPDFOptions">
		<div class="inner">
			<h2>Print to PDF</h2>
			<div class="content">
				<div>
					<p>Print to PDF coming soon.</p>
                    <div class="two-columns">
                        <div :class="['button', printing ? 'disabled' : 'action']" @click="doPrintPDF('transaction_log')">Transaction Log</div>
                        <div :class="['button', printing ? 'disabled' : 'action']" @click="doPrintPDF('ad_record')">A&D Record</div>
                    </div>
				</div>
			</div>
			<div class="controls">
				<div class="button neutral spaced" @click="showPDFOptions = false">Cancel</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>
</template>

<script>
export default {
	name: 'firearms-transactions',
	data() {
		return {
            loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			page: 1,
			clientId: '',
			filters: {
				page: 1,
				search_term: '',
                ffl_transaction_type_id: '',
                start_date: '',
				end_date: ''
			},
            fflTransactionTypes: [],
			list: [],
			paging: {},
			showDetail: false,
			detail: {},
            showExportOptions: false,
            showPDFOptions: false,
            printing: false,
            saving: false
		}
	},
    created() {
		this.apiCall({ destination: 'get_ffl_transaction_record_settings' }).then(obj => {
			this.fflTransactionTypes = obj.ffl_transaction_types
			this.employee_name = this.entry.employee_name = this.$fullName(obj.user_contact)
		}).catch(err => {
			console.log(err)
		})
		var oneMonthAgo = new Date()
		oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
		this.filters.start_date = oneMonthAgo.toISOString().slice(0,10)
		this.filters.end_date = new Date().toISOString().slice(0,10)
		this.getList()
    },
	computed: {
		hasFilters() {
			return this.filters.start_date || this.filters.end_date || this.filters.search_term
		}
	},
	methods: {
		getList(resetPage = false) {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Loading transactions...'
			this.messageStatus = 'waiting'
			this.showDetail = false
            if (resetPage) {
                this.filters.page = 1
            }
			this.apiCall({ destination: 'get_list_ffl_transactions', data: this.filters }).then(obj => {
                this.loading = false
				this.messageStatus = obj.status
				this.message = ''
				this.list = obj.list
				this.paging = obj.paging
				this.clientId = obj.client_id
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		getDetail(getItemId) {
			this.apiCall({ destination: 'get_item_ffl_transaction', data: { ffl_transaction_log_id: getItemId } }).then(obj => {
				this.detail = obj.detail
				this.showDetail = true
			}).catch(err => {
				console.log(err)
			})
		},
        saveDetail() {
            if (this.saving) { return }
            this.saving = true
			this.message = 'Saving transaction...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: 'update_item_ffl_transaction', data: this.detail }).then(obj => {
				this.messageStatus = obj.status
                if (obj.status == 'success') {
                    this.message = 'Transaction saved!'
                    this.messageTimeout = 2000
                } else {
                    this.message = obj.message || 'There was an error saving this transaction.'
                }
				this.saving = false
			}).catch(err => {
				this.saving = false
				console.log(err)
			})
        },
		backToList() {
			this.showDetail = false
			this.detail = {}
            this.getList()
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		clearFilters() {
			if (!this.hasFilters) { return }
			this.filters = {
				page: 1,
				ffl_transaction_type_id: '',
				start_date: '',
				end_date: '',
				search_term: ''
			}
            var oneMonthAgo = new Date()
            oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
            this.filters.start_date = oneMonthAgo.toISOString().slice(0,10)
            this.filters.end_date = new Date().toISOString().slice(0,10)
			this.getList()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		doPrintPDF(which) {
			let pdfLink = this.getPDFAPIEndpoint + '?action=' + which + '&transaction_id=' + this.detail.ffl_transaction_log_id + '&fd_token=' + getCookie('dashboard_token')
			window.open(pdfLink, '_blank');
			this.showPDFOptions = false
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
